// Мутации для грида
export const SET_GRID = 'SET_GRID';
